import ActionTypes from '../constants';

const initialState = {
    dashboard: {},
    logs: {},
    // loading: false,
};

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETDASHBOARDSUCCESS:
            return {
                ...state,
                dashboard: action.payload,
            }
        case ActionTypes.GETLOGSSUCCESS:
            return {
                ...state,
                logs: action.payload,
            }
        default:
            return state;
    }
}

export default dashboardReducer;